import React from 'react';
import Field from '../../Field';
import { Fields } from '../InfoContainer/info-container-styles';

const BasicRequirementsInfo = ({ leadData }) => {
  const preference = leadData?.preference;
  return (
    <Fields>
      <Field isRequired label="Bed" value={preference?.bedroom ?? 'N/A'} />
      <Field isRequired label="Bath" value={preference?.bathroom ?? 'N/A'} />
      <Field label="Move-in" value={preference?.moveIn || 'N/A'} />
      <Field
        label="Budget"
        value={preference?.budgetMin ? `$${preference.budgetMin}` : 'N/A'}
      />
    </Fields>
  );
};

export default BasicRequirementsInfo;
